export const whatEnv = () => {
  return process.env.RAILS_ENV;
}
